module.exports = {
	"button.label.read_more": "Les mer",
	"button.label.read_less": "Les mindre"
};


//////////////////
// WEBPACK FOOTER
// ../resources/strings/no_NO.json
// module id = 661
// module chunks = 0